import React from 'react';
import clsx from 'clsx';
import { Box, Typography } from '@material-ui/core';
import SvgIcons from './assets';
import { useStyles } from './styles';

export const ChipInfo = (props: any) => {
  const { text, type } = props;
  const classes = useStyles();

  const chipInfomationStyle = (type: string) =>
    clsx({
      [classes.infoBanner]: true,
      [classes.infoStyle]: type === 'info',
      [classes.warningStyle]: type === 'warning',
    });

  return (
    <Box className={chipInfomationStyle(type)}>
      <Box>
        {type === 'warning' ? (
          <SvgIcons.WarningCircleIcon className={classes.infoIcon} />
        ) : (
          <SvgIcons.InfoCircleIcon className={classes.infoIcon} />
        )}
      </Box>
      <Box className={classes.textStyle}>
        <Typography variant="body2">{text}</Typography>
      </Box>
    </Box>
  );
};

export default ChipInfo;
